/**
 * Mutually-exclusive selection group of a document product, or null when the product is in no
 * group — backend-computed (ISSUE-2866): every product of the group resolves to the same single
 * DocEstate document, so only one may be selected per property. The backend emits the field only
 * while its DocEstate bewilu migration flag is on, so the frontend needs no flag of its own.
 */
export enum DocumentSelectionGroup {
  BEWILLIGUNGSURKUNDE = 'BEWILLIGUNGSURKUNDE',
}
